import { h } from 'preact'
import loadingSpinnerView from './loading-spinner'

export default function loading (msg = '🧘‍♀️ Take a breath 🧘‍♂️') {
  return h('div', { id: 'loading' },
    loadingSpinnerView(),
    h('h1', {}, msg)
  )
}
